import {ComponentData} from "../../engine/tools/EntityManager";

export type AnimationId = string

export class AnimationPlayer implements ComponentData {

    animation: AnimationId;
    currentFrameId: number = 0
    isPlaying: boolean = true
    wasPlaying: boolean = false
    timeSinceLastFrame: number = 0
    lastFrameTime: number = 0

    constructor(options?: Partial<AnimationPlayer>) {
        Object.assign(this, options)
    }
}